<script setup lang="ts">
import { storeToRefs } from 'pinia'
import AdvisedActionsPanel from '@/features/actions/components/AdvisedActionsPanel.vue'
import EventSetupContent from '@/features/eventDetails/components/EventSetupContent.vue'
import ProductHistory from '@/features/eventDetails/components/ProductHistory.vue'
import EventTypeLegend from '@/features/sidePanel/components/EventTypeLegend.vue'
import FavouriteSKUs from '@/features/sidePanel/components/FavouriteSKUs.vue'
import HowTo from '@/features/sidePanel/components/HowTo.vue'
import SaleDaysSummaryPanel from '@/features/sidePanel/components/SaleDaysSummaryPanel.vue'
import { useSidebarStore } from '@/features/sidePanel/useSidebarStore'
import { SidebarContent } from '@/types'

const { isSidebarVisible } = storeToRefs(useSidebarStore())
</script>

<template>
	<transition name="slide">
		<div v-if="isSidebarVisible(SidebarContent.EVENT_SETUP)" class="transition">
			<EventSetupContent />
		</div>
	</transition>

	<transition name="slide">
		<div v-if="isSidebarVisible(SidebarContent.PRODUCT_HISTORY)" class="transition">
			<ProductHistory />
		</div>
	</transition>

	<transition name="slide">
		<div v-if="isSidebarVisible(SidebarContent.GUIDE)" class="transition">
			<HowTo />
		</div>
	</transition>

	<transition name="slide">
		<div v-if="isSidebarVisible(SidebarContent.EVENT_TYPE_LEGEND)" class="transition">
			<EventTypeLegend />
		</div>
	</transition>

	<transition name="slide">
		<div v-if="isSidebarVisible(SidebarContent.FAVOURITE_SKUS)" class="transition">
			<FavouriteSKUs />
		</div>
	</transition>

	<transition name="slide">
		<div v-if="isSidebarVisible(SidebarContent.SALE_DAYS_SUMMARY)" class="transition">
			<SaleDaysSummaryPanel />
		</div>
	</transition>

	<transition name="slide">
		<div v-if="isSidebarVisible(SidebarContent.ADVISED_ACTIONS)" class="transition">
			<AdvisedActionsPanel />
		</div>
	</transition>
</template>

<style scoped lang="scss">
.transition {
	@apply fixed right-0 z-40 flex h-screen flex-col bg-level-00 transition-all duration-300;
	box-shadow: -8px 0px 8px -8px rgb(0 0 0 / 50%);
}
</style>
